import React, { useState, useEffect } from 'react';
import './Podium.css';

const Podium = ({ raceId, drivers, onSubmit, existingPick }) => {
  const [picks, setPicks] = useState({
    firstPlace: existingPick?.firstPlace?._id || existingPick?.firstPlace || '',
    secondPlace: existingPick?.secondPlace?._id || existingPick?.secondPlace || '',
    thirdPlace: existingPick?.thirdPlace?._id || existingPick?.thirdPlace || '',
  });
  const [raceStarted, setRaceStarted] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(null);

  useEffect(() => {
    // Check race start time and disable if started
    const checkRaceStart = async () => {
      try {
        const response = await fetch(`/api/races/${raceId}`);
        const race = await response.json();
        const startTime = new Date(race.startTime);
        const now = new Date();
        
        if (now > startTime) {
          setRaceStarted(true);
        } else {
          const timeLeft = startTime - now;
          setTimeRemaining(Math.floor(timeLeft / 1000));
        }
      } catch (error) {
        console.error('Error checking race start:', error);
      }
    };

    checkRaceStart();
    const interval = setInterval(checkRaceStart, 1000);
    return () => clearInterval(interval);
  }, [raceId]);

  const handleSelectDriver = (position, driverId) => {
    setPicks({ ...picks, [position]: driverId });
  };

  const handleSubmit = () => {
    if (!picks.firstPlace || !picks.secondPlace || !picks.thirdPlace) {
      alert('Please select drivers for all three positions');
      return;
    }
    
    if (picks.firstPlace === picks.secondPlace || picks.firstPlace === picks.thirdPlace || picks.secondPlace === picks.thirdPlace) {
      alert('You cannot select the same driver for multiple positions');
      return;
    }
    
    onSubmit(picks);
  };

  if (raceStarted) {
    return (
      <div className="podium-container">
        <div className="race-locked">
          <h2>🏁 Race has started!</h2>
          <p>You can no longer make picks for this race.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="podium-container">
      <div className="podium-header">
        <h2>{existingPick ? 'Edit Your Pick' : 'Pick the Podium'}</h2>
        {timeRemaining > 0 && (
          <p className="time-remaining">
            ⏱ Picks lock in {Math.floor(timeRemaining / 3600)}h {Math.floor((timeRemaining % 3600) / 60)}m {Math.floor(timeRemaining % 60)}s
          </p>
        )}
      </div>

      <div className="podium">
        <div className="podium-position second">
          <div className="medal-2">2nd</div>
          <select 
            value={picks.secondPlace} 
            onChange={(e) => handleSelectDriver('secondPlace', e.target.value)}
          >
            <option value="">Select 2nd Place</option>
            {drivers.map(driver => (
              <option key={driver._id} value={driver._id}>
                {driver.name}
              </option>
            ))}
          </select>
        </div>

        <div className="podium-position first">
          <div className="medal-1">🥇 1st</div>
          <select 
            value={picks.firstPlace} 
            onChange={(e) => handleSelectDriver('firstPlace', e.target.value)}
          >
            <option value="">Select 1st Place</option>
            {drivers.map(driver => (
              <option key={driver._id} value={driver._id}>
                {driver.name}
              </option>
            ))}
          </select>
        </div>

        <div className="podium-position third">
          <div className="medal-3">3rd</div>
          <select 
            value={picks.thirdPlace} 
            onChange={(e) => handleSelectDriver('thirdPlace', e.target.value)}
          >
            <option value="">Select 3rd Place</option>
            {drivers.map(driver => (
              <option key={driver._id} value={driver._id}>
                {driver.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <button 
        className="submit-button" 
        onClick={handleSubmit}
        disabled={!picks.firstPlace || !picks.secondPlace || !picks.thirdPlace}
      >
        {existingPick ? 'Update Pick' : 'Submit Pick'}
      </button>
    </div>
  );
};

export default Podium;